import type { CollabCommentData } from '@examdojo/core/tiptap-react-ui-components/lib/collab-config';
import type { TiptapCollabProvider } from '@tiptap-pro/provider';
import { useCallback, useState } from 'react';
import { UserAvatar } from './comment-card';

interface ThreadComposerProps {
  provider: TiptapCollabProvider;
  threadId: string;
  userId: string;
  userName: string;
  userAvatar?: string;
}

export function ThreadComposer({ provider, threadId, userId, userName, userAvatar }: ThreadComposerProps) {
  const [text, setText] = useState('');

  const handleSubmit = useCallback(() => {
    if (!text.trim()) return;

    provider.addComment(threadId, {
      content: text.trim(),
      data: { userId, userName, userAvatar } satisfies CollabCommentData,
    });

    setText('');
  }, [provider, threadId, text, userId, userName, userAvatar]);

  return (
    <div className="threads-panel-composer">
      <UserAvatar name={userName} avatarUrl={userAvatar} />

      <div className="threads-panel-composer-input-wrap">
        <textarea
          className="threads-panel-input"
          placeholder="Reply..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit();
            }
          }}
          rows={1}
        />
        {text.trim() && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button type="button" className="threads-panel-btn threads-panel-btn-primary" onClick={handleSubmit}>
              Reply
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
